import { apiRequestDev } from './apiRequest';

export const getAllWardShapes = async (config) => apiRequestDev(config, '/wards/shapes/');

export const getWardData = async (config, wardId) => apiRequestDev(config, `/wards/data/${wardId}`);
